export function Button({children, variant = 'solid', className = '', ...props}) {
    const baseStyles =
        'focus:outline-none focus:ring-2 focus:ring-offset-1 transition-colors duration-150';

    const variants = {
        solid: 'rounded-lg px-4 py-2 bg-button text-white hover:bg-hover focus:ring-black-500',
        productCard: 'bg-transparent text-blue-600 font-black active:underline focus:ring-2 focus:ring-blue-400 px-2 py-1 mt-3',
        menu: 'rounded-lg px-4 py-2 font-semibold bg-button text-white hover:bg-hover focus:ring-black-500',
        ghost: 'rounded-md px-3 py-1.5 font-medium bg-transparent text-white hover:bg-white hover:text-primary focus:ring-white',
        danger: 'rounded-lg px-4 py-2 font-medium bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
        outline: 'rounded-md px-4 py-2 font-medium border border-gray-300 text-gray-700 bg-white hover:bg-gray-50',
        arrow: 'px-3 py-1 bg-gray-200 rounded disabled:opacity-50',
    };

    const styles = `${baseStyles} ${variants[variant] || variants.solid} ${className}`;

    return (
        <button className={styles} {...props}>
            {children}
        </button>
    );
}
